export default "__VITE_ASSET__DvFnPpW0__"